module.exports = __webpack_public_path__ + "img/2-3.0e72e79d.png";